import { ADMIN_FUNCTION, ADMIN_GET_ALL_COMPANIES } from "../actions/types";

const initialState = {
  userInfo: [],
  companies: [],
  affiliates: [],
  freeItems: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADMIN_FUNCTION:
      if (action.payload.users) {
        return {
          ...state,
          userInfo: action.payload.users,
          affiliates: action.payload.affiliates,
          freeItems: action.payload.freeItems,
        };
      } else
        return {
          ...state,
        };

    case ADMIN_GET_ALL_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    default:
      return state;
  }
}
